import React from 'react'
import { Box, Dialog, DialogContent, Typography } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { ErrorOutlineOutlined } from '@material-ui/icons'

const useStyles = makeStyles(() => ({
  dialog: {
    width: '500px',
    margin: '0 auto',
    '& .MuiDialog-paperWidthSm': {
      width: '400px',
      paddingBottom: '20px'
    }
  },
  headerContainer: {
    display: 'flex',
    flexDirection:'column',
    alignItems: 'center'
  },
  icon: {
    marginTop: '20px',
    fontSize: '100px',
    transform: 'rotate(180deg)',
    color: '#c9dae1'
  },
  title: {
    margin: '20px 0 13px',
    fontSize: '27px',
    color: 'rgba(0,0,0,.65)',
    fontWeight: 'bold'
  },
  textTitle: {
    fontSize: '16px',
    color: 'rgba(0,0,0,.65)',
    fontWeight: 600,
    textTransform: 'capitalize'
  },
  text: {
    fontSize: '16px',
    color: 'rgba(0,0,0,.65)',
    fontWeight: 400
  }
}))


const ModalRejections = ({ info, show, onClose }) => {
  const classes = useStyles()
  const razon = info && info?.razon.split('.')
  const description = info && razon[1].split(',').map( value => value.split(':'))
  console.log('description', description)
  const verificacion = info && Object.entries(info?.verificacion)
  return (
    razon &&
    <Dialog open={show} onClose={onClose} className={classes.dialog}>
        <Box className={classes.headerContainer}>
          <ErrorOutlineOutlined className={classes.icon} />
          <Typography variant='title' className={classes.title}>{razon[0]}</Typography>
        </Box>
        <DialogContent >
            {description?.map(item => (
            <Box style={{marginRight: '4px'}}>
              <Typography variant='p' className={classes.textTitle}>{item[0]}: </Typography>
              <Typography variant='p' className={classes.text}>{item[1]}</Typography>
            </Box>
          ))}
          {verificacion?.map(item => (
            <Box style={{marginRight: '4px'}}>
              <Typography variant='p' className={classes.textTitle}>{item[0]}: </Typography>
              <Typography variant='p' className={classes.text}>{item[1]}</Typography>
            </Box>
          ))}

        </DialogContent>
    </Dialog>
  )
}

export {ModalRejections}